import {fire} from "../../fire";
import {setDoc, doc, deleteDoc, onSnapshot, updateDoc, writeBatch, getDocs, collection} from 'firebase/firestore'

export const borrarDoc = (col, obj) => {

    if (!obj.id) {
        let id = new Date().getTime() + col.substr(col.length - 3, col.length).toUpperCase();
        obj.id = id;
    }

    return new Promise(resolve => {

        deleteDoc(doc(fire, col, obj.id)).then((dox) => {
            return resolve({res: true, data: dox})
        }).catch((err) => {
            //  alert(err.message)
            return resolve({res: false, data: err.message})
        })
    })

}